import React, { Fragment } from "react";

import { BrowserRouter, Route, Routes } from "react-router-dom";

// layout
import Header from "./Header";
import Footer from "./Footer";
import Sections from "../sections";

// Pages
import Audits from "../pages/Audits";
import AuditProcess from "../pages/AuditProcess";
import Blog from "../pages/Blog"; // create this page

import PhishingAttacks from "../pages/Blog/Articles/PhishingAttacks";
import SubtleSolidityBugs from "../pages/Blog/Articles/SubtleSolidityBugs";
import BeyondtheCode from "../pages/Blog/Articles/BeyondtheCode";
import TestArticle from "../pages/Blog/Articles/TestArticle";
import ScalingAdversarialMindset from "../pages/Blog/Articles/ScalingAdversarialMindset";
import EoyReport2025 from "../pages/Blog/Articles/eoyReport2025";

const Layout = () => {
  return (
    <BrowserRouter>
      <Fragment>
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Sections />} />
            <Route path="audits" element={<Audits />} />
            <Route path="blog" element={<Blog />} />

            <Route
              path="articles/phishing-attacks-and-social-engineering-in-web3"
              element={<PhishingAttacks />}
            />
            <Route
              path="articles/most-subtle-solidity-bugs-from-audits"
              element={<SubtleSolidityBugs />}
            />
            <Route path="articles/test-article" element={<TestArticle />} />
            <Route
              path="articles/beyond-the-code"
              element={<BeyondtheCode />}
            />
            <Route
              path="articles/scaling-adversarial-mindset"
              element={<ScalingAdversarialMindset />}
            />
            <Route
              path="articles/eoy-security-report-2025"
              element={<EoyReport2025 />}
            />
          </Routes>
        </main>
        <Footer />
      </Fragment>
    </BrowserRouter>
  );
};

export default Layout;
